import EmailDeliveryReport from "./EmailDeliveryReport";

export default EmailDeliveryReport;
